var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCareProgramVasOutlined = function SvgCareProgramVasOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.966 8.567c-.015-.697-.03-1.357-.03-1.991 0-.961-.92-1.743-2.052-1.743-4.377 0-7.699-1.06-10.454-3.336-.803-.663-2.059-.663-2.861 0-2.755 2.276-6.077 3.336-10.454 3.336-1.13 0-2.051.782-2.051 1.743 0 .647-.015 1.313-.03 2.019-.075 3.291-.167 7.388 1.451 11.107.89 2.045 2.238 3.822 4.005 5.282 2.014 1.662 4.65 2.981 7.837 3.92a2.376 2.376 0 0 0 1.344 0c3.187-.939 5.824-2.258 7.838-3.92 1.767-1.46 3.115-3.237 4.005-5.282 1.619-3.72 1.527-7.816 1.453-11.108v-.027Z",
    fill: "#fff",
    stroke: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.475 12.665c0 4.972-5.876 8.252-7.664 9.123a1.19 1.19 0 0 1-1.022 0c-1.788-.871-7.664-4.049-7.664-9.123 0-2.563 1.89-4.665 4.19-4.665 1.839 0 3.372 1.281 3.934 3.075C15.81 9.281 17.395 8 19.183 8c2.401 0 4.292 2.102 4.292 4.665Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "CareProgramVasOutlined_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 17,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.475 12.665c0 4.972-5.876 8.252-7.664 9.123a1.19 1.19 0 0 1-1.022 0c-1.788-.871-7.664-4.049-7.664-9.123 0-2.563 1.89-4.665 4.19-4.665 1.839 0 3.372 1.281 3.934 3.075C15.81 9.281 17.395 8 19.183 8c2.401 0 4.292 2.102 4.292 4.665Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#CareProgramVasOutlined_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.35 14.415c0 4.972-5.876 8.252-7.664 9.123a1.19 1.19 0 0 1-1.022 0C13.876 22.667 8 19.49 8 14.415c0-2.563 1.89-4.665 4.19-4.665 1.839 0 3.372 1.281 3.934 3.075.562-1.794 2.146-3.075 3.934-3.075 2.401 0 4.292 2.102 4.292 4.665Z",
    fill: "#40B6C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.592 21.339-.005.003a.691.691 0 0 1-.574 0l-.005-.003c-.878-.428-2.745-1.416-4.385-2.906-1.647-1.496-2.998-3.435-2.998-5.768 0-2.339 1.716-4.165 3.69-4.165 1.589 0 2.95 1.108 3.457 2.725a.5.5 0 0 0 .954 0C16.23 9.61 17.64 8.5 19.183 8.5c2.084 0 3.792 1.834 3.792 4.165 0 2.28-1.35 4.22-3 5.73-1.642 1.505-3.51 2.518-4.383 2.944Z",
    stroke: "#222",
    strokeLinejoin: "round"
  }))));
};
export default SvgCareProgramVasOutlined;